import {
  INSIGHTS_TIMEOUT_MS,
  REPORTING_STORE_API_BASE,
} from '@/common/api/reporting-store/constants';
import { tempoApi } from '@/common/api/tempoApi';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import { trendsProgressSchema } from '@/common/api/types/dashboard/trends';
import { buildInsightsApiFilter } from '@/features/insights-dashboard/utils/buildInsightsApiFilter';

const getTrendsProgress = async ({
  filters,
  scopeItemId,
  loopId,
  dateRange,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
  dateRange?: { from: string; to: string };
}) => {
  const filterString = buildInsightsApiFilter(filters, scopeItemId, loopId);

  const response = await tempoApi()
    .post(`${REPORTING_STORE_API_BASE}/trends/progress`, {
      json: {
        filter: filterString ?? '',
        ...(dateRange && { dateRange }),
      },
      timeout: INSIGHTS_TIMEOUT_MS,
    })
    .json();

  return trendsProgressSchema.parse(response);
};

export const TrendsApi = {
  getTrendsProgress,
};
